export default "__VITE_ASSET__dBKAGqOT__"